import React, { FC, ReactElement } from "react";
import {
  DetailedCard,
  SubtitleItem,
} from "../../../../components/GeneralUI/DetailedCardComponents";

export type DynamicFormCardWrapperProps = {
  title: string;
  enabled: boolean;
  navigateUrl?: string;
  subtitles?: SubtitleItem[];
  textAtRight?: string;
  buttonAtRight?: ReactElement;
  iconAtRight?: ReactElement;
};

export const DynamicFormCardWrapper: FC<
  React.PropsWithChildren<DynamicFormCardWrapperProps>
> = ({
  title,
  subtitles,
  enabled,
  navigateUrl,
  textAtRight,
  buttonAtRight,
  iconAtRight,
}) => {
  return (
    <DetailedCard
      isExtended={true}
      link={navigateUrl}
      title={title}
      subtitles={subtitles}
      specialStyle={
        enabled
          ? "bg-stone-50 dark:bg-stone-800"
          : "bg-slate-100 dark:bg-stone-900"
      }
      textAtRight={textAtRight}
      iconAtRight={iconAtRight}
      buttonAtRight={buttonAtRight}
    ></DetailedCard>
  );
};
